export enum DndType {
  ImageInSelector = 'ImageInSelector',
  LocalizationBasicItem = 'LocalizationBasicItem',
  LocalizationContactItem = 'LocalizationContactItem',
}
